import React from 'react';
import styled from 'styled-components';
import AlertInfo from '../../../components/common/alert/AlertInfo';
import { GIButton, Modal } from 'app-components';
import { ModalContextType } from '../../../contexts/modalContext';

const StyledAlertWrapper = styled.div`
    .gi-alert {
        padding: 10px;
    }
`;

const StyledButton = styled.div`
    .gi-button {
        text-transform: none;
    }
`;


interface IModalProps extends ModalContextType {}
export default function DocumentTypeModal({ closeModal }: IModalProps) {
    function onClose() {
        closeModal('documentTypeModal');
    }

    return (
        <Modal id="documentTypeModal">
            <Modal.Header
                id="documentTypeModalHeader"
                titleId="dmi.applicantVerifications.invalidselection"
                onHide={onClose}
            />
            <Modal.Body id="documentTypeModalBody">
                <StyledAlertWrapper>
                    <AlertInfo id="dmi.applicantVerifications.alert.documentType" />
                </StyledAlertWrapper>
            </Modal.Body>
            <Modal.Controls>
                <StyledButton>
                    <GIButton id="button" onClickHandler={onClose} variant="primary" labelId="button.close" />
                </StyledButton>
            </Modal.Controls>
        </Modal>
    );
}
